import { useTheme, type ThemePreference } from '@/lib/theme';
import { cx, Icon } from './ui';

const OPTIONS: { value: ThemePreference; label: string; icon: 'sun' | 'moon' | 'monitor' }[] = [
  { value: 'light', label: 'Light', icon: 'sun' },
  { value: 'dark', label: 'Dark', icon: 'moon' },
  { value: 'system', label: 'System', icon: 'monitor' },
];

/** Light / dark / system toggle. The choice is remembered in localStorage. */
export function ThemeSwitcher() {
  const { preference, setPreference } = useTheme();
  return (
    <div role="radiogroup" aria-label="Theme" className="inline-flex rounded-lg border border-line bg-sunken p-0.5">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          role="radio"
          aria-checked={preference === o.value}
          title={`${o.label} theme`}
          onClick={() => setPreference(o.value)}
          className={cx(
            'inline-flex items-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition',
            preference === o.value ? 'bg-surface text-ink shadow-sm ring-1 ring-line' : 'text-muted hover:text-ink',
          )}
        >
          <Icon name={o.icon} className="size-3.5" />
          <span className="hidden sm:inline">{o.label}</span>
        </button>
      ))}
    </div>
  );
}
